import { getNestedValue } from "./getNestedValue";

/**
 * Check if a nested path exists and has a truthy value in an object
 * Example: hasNestedValue({ user: { profile: { name: "John" } } }, "user.profile.name") => true
 */
export function hasNestedValue(obj: unknown, path: string): boolean {
  const value = getNestedValue(obj, path);
  return value !== null && value !== undefined;
}
